module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "engineerManage"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "150px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "filter-method": _vm.PinyinMatch,
      "placeholder": "工程师"
    },
    on: {
      "change": _vm.changeName
    },
    model: {
      value: (_vm.searchForm.name),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "name", $$v)
      },
      expression: "searchForm.name"
    }
  }, _vm._l((_vm.engineersList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "160px",
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入工程师账号"
    },
    model: {
      value: (_vm.searchForm.number),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "number", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择工程师类型"
    },
    model: {
      value: (_vm.searchForm.type),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "type", $$v)
      },
      expression: "searchForm.type"
    }
  }, _vm._l((_vm.engineerTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "150px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择所属门店"
    },
    model: {
      value: (_vm.searchForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "shop", $$v)
      },
      expression: "searchForm.shop"
    }
  }, _vm._l((_vm.shopListData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "200px",
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "启用状态：",
      "prop": "state",
      "label-width": "100px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.searchForm.state),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "state", $$v)
      },
      expression: "searchForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearFrom()
      }
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.basicsAuth.storeEngineerAdd) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createEngineer()
      }
    }
  }, [_vm._v("新建工程师")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "id": "tableId",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "name",
      "label": "工程师姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "loginName",
      "label": "工程师账号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "type",
      "label": "工程师类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'SM') ? _c('span', [_vm._v("上门工程师")]) : _c('span', [_vm._v("门店工程师")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "attribute2",
      "label": "工程师等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "attribute3",
      "label": "基础包"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "启用状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 1) ? _c('span', [_vm._v("启用")]) : _c('span', [_vm._v("禁用")])]
      }
    }])
  }), _vm._v(" "), (_vm.basicsAuth.storeEngineerEdit) ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exitBtn(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }], null, false, 3432076914)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogCreate,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogCreate = $event
      },
      "close": function($event) {
        return _vm.emptyDialog()
      }
    }
  }, [_c('el-form', {
    ref: "EngineerForm",
    attrs: {
      "rules": _vm.EngineerFormRules,
      "model": _vm.EngineerForm,
      "label-width": "65px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择工程师类型"
    },
    model: {
      value: (_vm.EngineerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "type", $$v)
      },
      expression: "EngineerForm.type"
    }
  }, _vm._l((_vm.engineerTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.EngineerForm.name),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "accountState"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择城市"
    },
    model: {
      value: (_vm.EngineerForm.accountState),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "accountState", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.accountState"
    }
  }, _vm._l((_vm.regionList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号",
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.EngineerForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "loginName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "等级",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择工程师等级"
    },
    model: {
      value: (_vm.EngineerForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "grade", $$v)
      },
      expression: "EngineerForm.grade"
    }
  }, _vm._l((_vm.enginnerGradeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.gradeName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "号码",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "clearable": "",
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.EngineerForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "phone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工号",
      "prop": "jobNo"
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "clearable": "",
      "type": "text",
      "placeholder": "请输入工号"
    },
    model: {
      value: (_vm.EngineerForm.jobNo),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "jobNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.jobNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "门店",
      "prop": "shop"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择所属门店"
    },
    model: {
      value: (_vm.EngineerForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "shop", $$v)
      },
      expression: "EngineerForm.shop"
    }
  }, _vm._l((_vm.shopListData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "autocomplete": "off",
      "placeholder": "请选择性别"
    },
    model: {
      value: (_vm.EngineerForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "sex", $$v)
      },
      expression: "EngineerForm.sex"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "男",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "女",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), (_vm.dialogMenuStatus == 'create') ? _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "password",
      "placeholder": "请输入工程师密码"
    },
    model: {
      value: (_vm.EngineerForm.password),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dialogMenuStatus == 'update') ? _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "password",
      "placeholder": "请输入工程师密码"
    },
    model: {
      value: (_vm.EngineerForm.password),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "基础包",
      "prop": "packType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择基础包"
    },
    model: {
      value: (_vm.EngineerForm.packType),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "packType", $$v)
      },
      expression: "EngineerForm.packType"
    }
  }, _vm._l((_vm.enginnerPackTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.packName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "email",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.EngineerForm.email),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄",
      "prop": "age"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "number",
      "placeholder": "请输入年龄"
    },
    model: {
      value: (_vm.EngineerForm.age),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "age", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "EngineerForm.age"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "state",
      "label-width": "100px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.EngineerForm.state),
      callback: function($$v) {
        _vm.$set(_vm.EngineerForm, "state", $$v)
      },
      expression: "EngineerForm.state"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus == 'create') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createData('EngineerForm')
      }
    }
  }, [_vm._v("立即创建")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateData('EngineerForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-75e5a186","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storeManage/storeEngineerManage.vue
// module id = 1718
// module chunks = 0